import React from 'react';
import CarHome from './CarHome/CarHome';

const CheckOut = () => {
     const cars = [
          {
               "id": "1",
               "name": "first car",
               "description": "this is my first car website",
               "price": "3454",
               "supplierName": "Akas hosain",
               "img": "https://www.drivespark.com/car-image/640x480x100/car/x7312319-volvo_xc60.jpg.pagespeed.ic.nWeriRl0_O.jpg"
          },
          {
               "id": "2",
               "name": "first car",
               "description": "this is my first car website",
               "price": "3454",
               "supplierName": "Akas hosain",
               "img": "https://www.drivespark.com/car-image/640x480x100/car/x7312319-volvo_xc60.jpg.pagespeed.ic.nWeriRl0_O.jpg"
          },
          {
               "id": "3",
               "name": "first car",
               "description": "this is my first car website",
               "price": "3454",
               "supplierName": "Akas hosain",
               "img": "https://www.drivespark.com/car-image/640x480x100/car/x7312319-volvo_xc60.jpg.pagespeed.ic.nWeriRl0_O.jpg"
          },
          {
               "id": "4",
               "name": "first car",
               "description": "this is my first car website",
               "price": "3454",
               "supplierName": "Akas hosain",
               "img": "https://www.drivespark.com/car-image/640x480x100/car/x7312319-volvo_xc60.jpg.pagespeed.ic.nWeriRl0_O.jpg"
          },
          {
               "id": "5",
               "name": "first car",
               "description": "this is my first car website",
               "price": "3454",
               "supplierName": "Akas hosain",
               "img": "https://www.drivespark.com/car-image/640x480x100/car/x7312319-volvo_xc60.jpg.pagespeed.ic.nWeriRl0_O.jpg"
          },
          {
               "id": "6",
               "name": "first car",
               "description": "this is my first car website",
               "price": "3454",
               "supplierName": "Akas hosain",
               "img": "https://www.drivespark.com/car-image/640x480x100/car/x7312319-volvo_xc60.jpg.pagespeed.ic.nWeriRl0_O.jpg"
          },
     ]
     return (
          <div>
               <div className='cars mt-4 container'>
                    {
                         cars.map(car => <CarHome
                              key={car.id}
                              car={car}
                         ></CarHome>).slice(0, 3)
                    }
               </div>
          </div>
     );
};

export default CheckOut;